export interface LoqateFindItem {
  Id: string;
  Type: string;
  Text: string;
  Highlight: string;
  Description: string;
}

export interface LoqateFindResponse {
  Items: LoqateFindItem[];
}

export interface LoqateRetrieveItem {
  Id: string;
  DomesticId?: string;
  Language?: string;
  LanguageAlternatives?: string;
  Department?: string;
  Company?: string;
  SubBuilding?: string;
  BuildingNumber?: string;
  BuildingName?: string;
  SecondaryStreet?: string;
  Street?: string;
  Block?: string;
  Neighbourhood?: string;
  District?: string;
  City?: string;
  Line1: string;
  Line2?: string;
  Line3?: string;
  Line4?: string;
  Line5?: string;
  AdminAreaName?: string;
  AdminAreaCode?: string;
  Province?: string;
  ProvinceName?: string;
  ProvinceCode?: string;
  PostalCode: string;
  CountryName?: string;
  CountryIso2?: string;
  CountryIso3?: string;
  CountryIsoNumber?: number;
  SortingNumber1?: string;
  SortingNumber2?: string;
  Barcode?: string;
  POBoxNumber?: string;
  Label?: string;
  Type?: string;
  DataLevel?: string;
  PostTown: string;
}

export interface LoqateRetrieveResponse {
  Items: LoqateRetrieveItem[];
}

// Loqate uses "Error" as the Type for error responses
interface LoqateErrorItem {
  Error: string;
  Description: string;
  Cause: string;
  Resolution: string;
}

export const searchLoqateAddresses = async (query: string, apiKey: string, containerId?: string): Promise<LoqateFindItem[]> => {
  if (!apiKey) return [];

  const params = new URLSearchParams({
    Key: apiKey,
    Text: query || '',
    Countries: 'US,CA,SG,AU,GB,NO,PH,JP,AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE',
    Bias: 'false',
    IsMiddleware: 'true',
  });

  if (containerId) {
    params.set('Container', containerId);
  }

  try {
    const response = await fetch(`https://api.addressy.com/Capture/Interactive/Find/v1.20/json6.ws?${params.toString()}`);
    if (!response.ok) throw new Error('Network response was not ok');
    const data: LoqateFindResponse = await response.json();
    
    // Loqate returns errors in the same array structure but with "Error" type or similar
    if (data.Items && data.Items.length > 0 && typeof (data.Items[0] as any).Error === 'string') {
       console.error('Loqate API Error:', (data.Items[0] as unknown as LoqateErrorItem).Description);
       return [];
    }
    
    return data.Items || [];
  } catch (error) {
    console.error('Failed to search addresses:', error);
    return [];
  }
};

export const retrieveLoqateAddress = async (id: string, apiKey: string): Promise<LoqateRetrieveItem | null> => {
  if (!id || !apiKey) return null;

  const params = new URLSearchParams({
    Key: apiKey,
    Id: id,
  });

  try {
    const response = await fetch(`https://api.addressy.com/Capture/Interactive/Retrieve/v1.00/json6.ws?${params.toString()}`);
    if (!response.ok) throw new Error('Network response was not ok');
    const data: LoqateRetrieveResponse = await response.json();
    
    if (data.Items && data.Items.length > 0) {
      if (typeof (data.Items[0] as any).Error === 'string') {
        console.error('Loqate API Error:', (data.Items[0] as unknown as LoqateErrorItem).Description);
        return null;
      }
      return data.Items[0];
    }
    
    return null;
  } catch (error) {
    console.error('Failed to retrieve address details:', error);
    return null;
  }
};
